import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (discussion) =>
    present(
      repository
        .removeDiscussion(discussion)
        .then(() => discussion)
        .catch(() => Promise.reject(discussion)),
    );
}

export type { Interactor };

export { createInteractor };
